import { Component, Inject, DestroyRef } from '@angular/core'
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { CommonModule } from '@angular/common'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NGXLogger } from 'ngx-logger'
import { SharedService } from '../../../services/shared.service'
import { InstantErrorStateMatcherService } from '../../../services/instant-error-state-matcher.service'
import { VehicleDTOExtended, VehiclesService } from '../../../services/vehicles.service'
import { TransifexService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'

@Component({
  selector: 'customer-portal-app-edit-mileage',
  standalone: true,
  templateUrl: './edit-mileage.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule
  ]
})
export class EditMileageComponent {
  mileageForm = new FormGroup({
    manualMileage: new FormControl<number | null>(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^([0-9]+$)'),
        Validators.max(9999999),
        Validators.min(1)
      ])
    )
  })

  matcher = new InstantErrorStateMatcherService()
  saving = false
  vehicleUpdated: VehicleDTOExtended
  imageUrl: string

  constructor (
    private readonly dialogRef: MatDialogRef<EditMileageComponent>,
    @Inject(MAT_DIALOG_DATA) public vehicle: VehicleDTOExtended,
    private readonly vehiclesService: VehiclesService,
    private readonly logger: NGXLogger,
    public sharedService: SharedService,
    public transifexService: TransifexService,
    private readonly destroyRef: DestroyRef
  ) {
    this.vehicleUpdated = vehicle
    this.mileageForm
      .get('manualMileage')
      .setValue(
        this.vehicle.manualMileage != null ? this.vehicle.manualMileage : null
      )
  }

  saveChanges (): void {
    this.saving = true
    const manualMileage = this.mileageForm.get('manualMileage').value
    // legacy fallback still needs the full vehicle (built immutably, no mutation)
    const legacyVehicle = {
      ...this.sharedService.removeExtraVehicleProperties(this.vehicleUpdated),
      manualMileage
    }
    this.vehiclesService.updateManualMileage(legacyVehicle, manualMileage)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.saving = false
          // close with the locally-known value we sent — the (optional) response field
          // can be undefined, which would leave the dialog stuck with no close/error
          this.dialogRef.close({ success: true, value: manualMileage })
        },
        error: error => {
          this.saving = false
          this.logger.debug(error)
          this.dialogRef.close({ success: false })
        }
      })
  }
}
